import MonthlyReportLayout from './MonthlyReportLayout';

export default MonthlyReportLayout;
